<template>

    <div class="fixed z-30 inset-0 w-full flex">
        <div class="absolute inset-0 flex flex-wrap h-screen p-5 bg-red-700 opacity-75">
            <div class="container mx-auto py-5 flex flex-wrap items-center">
                <div class="w-full md:w-6/12">
                    <h4 class="text-4xl lg:text-6xl text-white py-3">
                        遭遇到一些問題。
                    </h4>
                    <p class="text-lg text-white py-1" v-if="messages.length === 1">
                        {{ messages[0] }}
                    </p>
                    <ul class="text-lg text-white list-disc list-inside" v-if="messages.length > 1">
                        <li class="py-1" v-for="(msg, idx) in messages" :key="idx">
                            {{ msg }}
                        </li>
                    </ul>
                    <button class="w-40 mt-10 py-5 border border-white rounded-lg text-white cursor-pointer"
                        @click="confirm">
                        <span class="text-2xl leading-normal">
                            我知道了
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="hidden absolute w-6/12 top-0 right-0 md:flex flex-wrap h-screen p-5">
            <div class="container mx-auto py-5 flex flex-wrap items-center">
                <div class="w-9/12">
                    <img src="../assets/img/undraw_cancel_u1it.svg">
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props:{
        messages:{
            type: Array,
        }
    },

    methods:{
        confirm(){
            this.$emit('confirm')
        }
    }
}
</script>
